// return the tokens that should be saved with a correction
// This is used both on the field correction and spreadsheet correction

// fix fieldData type and tokens
export default function getTokensForCorrection(
  correctionValue: string,
  fieldData: any,
  tokens: any
) {
  let mytokens = [];
  if (tokens.length !== 0) {
    mytokens = tokens;
  } else if (fieldData) {
    mytokens = fieldData.tokens;
  }

  // avoid saving tokens with blank field
  if (!correctionValue || correctionValue.length === 0) {
    mytokens = [];
  }

  return mytokens;
}
